__turbopack_context__.v({
  "clientLayout": "global-module-scss-module__6lcjlG__clientLayout",
  "paginationWrapper": "global-module-scss-module__6lcjlG__paginationWrapper",
});
